import React from 'react';
import { IconBuilding } from './Icons';

function domainShort(domain) {
  if (!domain) return '—';
  const u = (domain || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
  return u.length > 20 ? u.substring(0, 20) + '…' : u;
}

function RegistryItemRow({ descriptor, onSelect }) {
  const companyData = descriptor.company_data || {};
  const companyName = companyData.company_name || descriptor.company_name || 'Unknown Company';
  const description = companyData.company_description || '';
  const industries = companyData.industries || [];
  const domain = descriptor.domain || '';

  return (
    <tr
      onClick={() => onSelect?.(descriptor)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect?.(descriptor);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`View details for ${companyName}`}
    >
      <td>
        <div className="ds-list-cell-company">
          <div className="ds-list-cell-icon">
            <IconBuilding aria-hidden />
          </div>
          <div>
            <div className="ds-list-cell-name">{companyName}</div>
            <div className="ds-list-cell-desc">
              {(description || '').substring(0, 45)}
              {description && description.length > 45 ? '…' : ''}
            </div>
          </div>
        </div>
      </td>
      <td>
        <span style={{ display: 'inline-block', padding: '4px 10px', background: 'var(--bg)', color: 'var(--text-muted)', fontSize: '12px', fontWeight: 500, borderRadius: 'var(--radius-sm)' }}>
          {industries[0] || '—'}
        </span>
      </td>
      <td>{domainShort(domain)}</td>
      <td>
        <button
          type="button"
          className="ds-list-view-btn"
          onClick={(e) => {
            e.stopPropagation();
            onSelect?.(descriptor);
          }}
        >
          View
        </button>
      </td>
    </tr>
  );
}

export default RegistryItemRow;
